/* eslint-disable import/no-unresolved */

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
// import { Autoplay } from "swiper/modules";
import { Container } from "react-bootstrap";
import {
  ImageElement,
  NoDataFound,
  TimelineModal,
  VideoElement,
} from "components/UiElement";
import { useEffect, useState, useCallback, useRef } from "react";
import { checkValidData } from "components/Formatter";
import { dayJsDateFormatter } from "utils";
import { Link } from "react-router-dom";
import { ext } from "helpers";

function TimelineSection({ id, getTimelineData, timelineData }) {
  const [datas, setDatas] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const sectionRef = useRef(null);

  // Check if device supports hover (non-touch devices)
  const isTouchDevice = useCallback(() => {
    return window.matchMedia("(hover: none)").matches;
  }, []);

  useEffect(() => {
    if (id) getTimelineData(id);
  }, []);

  // Close active item when clicking outside the timeline section
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sectionRef.current && !sectionRef.current.contains(event.target)) {
        setActiveIndex(null);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const handleCloseModal = () => {
    setShowModal(false);
  };
  const openImageModal = () => {
    setShowModal(!showModal);
  };
  return (
    <>
      {timelineData?.length > 0 && (
        <section
          ref={sectionRef}
          className="timelineSec position-relative py-80 overflow-hidden"
          id="timeline"
        >
          <Container>
            <div className="commonHead">
              <div className="commonHead_sub">Chronicles of a Life</div>
              <h2 className="commonHead_title">
                 Highlights of a Life Well Lived
              </h2>
            </div>
          </Container>
          {timelineData?.length > 0 ? (
            <div className="timelineSec_inner position-relative">
              <Container fluid>
                <div className="slider">
                  <Swiper
                    spaceBetween={0}
                    slidesPerView={2}
                    speed={1000}
                    autoplay={{
                      delay: 2500,
                      pauseOnMouseEnter: true,
                      disableOnInteraction: false,
                    }}
                    grabCursor="true"
                    breakpoints={{
                      0: {
                        slidesPerView: 1.5,
                        spaceBetween: 130,
                      },
                      400: {
                        slidesPerView: 1.5,
                        spaceBetween: 60,
                      },
                      576: {
                        slidesPerView: 2,
                        spaceBetween: 100,
                      },
                      992: {
                        slidesPerView: 4,
                      },
                      1200: {
                        slidesPerView: 4.5,
                      },
                      1599: {
                        slidesPerView: 5.5,
                      },
                    }}
                    // modules={[Autoplay]}
                    loop={timelineData?.length > 6}
                  >
                    {timelineData?.length > 0 &&
                      timelineData?.map((item, index) => {
                        return (
                          <SwiperSlide key={index}>
                            <div
                              className={`timeLine text-center position-relative ${
                                index % 4 === 0
                                  ? "timeLine-lg "
                                  : index % 2 === 0
                                  ? "timeLine-sm "
                                  : ""
                              }${activeIndex === index ? " is-active" : ""}`}
                            >
                              {ext?.[
                                item?.timelineImageUrl?.split(".")?.pop()
                              ] === "file" ? (
                                <Link
                                  className="timeLine_img mx-auto timeLine_img-pdf"
                                  key={index}
                                  target="_blank"
                                  to={item?.timelineImageUrl}
                                >
                                  <div className="box h-100">
                                    <div className="pdfBox d-flex align-items-center justify-content-center flex-column h-100">
                                      <Link
                                        to={item?.timelineImageUrl}
                                        target="_blank"
                                        className="timeLine_img_icon flex-shrink-0"
                                      >
                                        <em className="icon-pdf" />
                                      </Link>
                                      <h3 className="timeLine_img_txt mb-0 position-relative p-0">
                                        {checkValidData(item?.title)}
                                      </h3>
                                      <p className="p-0 mb-0 position-relative">
                                        {checkValidData(item?.description)}
                                      </p>
                                    </div>
                                  </div>
                                </Link>
                              ) : (
                                <div
                                  className={`timeLine_img mx-auto ${
                                    ext?.[
                                      item?.timelineImageUrl?.split(".")?.pop()
                                    ] === "audio" && "timeLine_img-audio"
                                  } ${
                                    ext?.[
                                      item?.timelineImageUrl?.split(".")?.pop()
                                    ] === "video" && "timeLine_img-video"
                                  }`}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    
                                    // On touch devices: first tap expands, second tap opens modal
                                    if (isTouchDevice()) {
                                      if (activeIndex === index) {
                                        // Already active, open the modal
                                        openImageModal(item?.id);
                                        setDatas(item);
                                        setActiveIndex(null);
                                      } else {
                                        // Activate this item
                                        setActiveIndex(index);
                                      }
                                    } else {
                                      // On desktop, just open the modal (hover handles expand)
                                      openImageModal(item?.id);
                                      setDatas(item);
                                    }
                                  }}
                                >
                                  {ext?.[
                                    item?.timelineImageUrl?.split(".")?.pop()
                                  ] === "video" && (
                                    <>
                                      <VideoElement
                                        previewSource={item?.timelineImageUrl}
                                        extraClassName="w-100 h-100 object-fit-cover z-1 position-relative"
                                        alt="timeline-img"
                                        controls={false}
                                      />{" "}
                                      <span className="timeLine_img_icon">
                                        <em className="icon-video" />
                                      </span>{" "}
                                    </>
                                  )}
                                  {ext?.[
                                    item?.timelineImageUrl?.split(".")?.pop()
                                  ] === "image" && (
                                    <>
                                      <ImageElement
                                        previewSource={item?.timelineImageUrl}
                                        className="w-100 h-100 object-fit-cover z-1 position-relative"
                                        alt="timeline-img"
                                      />
                                      <h3 className="timeLine_img_txt mb-0">
                                        {checkValidData(item?.title)}
                                      </h3>
                                    </>
                                  )}
                                  {ext?.[
                                    item?.timelineImageUrl?.split(".")?.pop()
                                  ] === "audio" && (
                                    <div className="box h-100">
                                      <span className="timeLine_img_icon">
                                        <em className="icon-mic" />
                                      </span>{" "}
                                    </div>
                                  )}{" "}
                                  <h3 className="timeLine_img_txt mb-0">
                                    {checkValidData(item?.title)}
                                  </h3>
                                </div>
                              )}{" "}
                              <div className="timeLine_year">
                                {dayJsDateFormatter(item?.date, "MMM DD, YYYY")}
                              </div>
                              <div className="borderTop" />
                              <div className="timeLine_circle position-absolute">
                                <span className="d-block" />
                              </div>
                            </div>
                          </SwiperSlide>
                        );
                      })}
                  </Swiper>
                </div>
              </Container>
            </div>
          ) : (
            <NoDataFound />
          )}
        </section>
      )}

      <TimelineModal
        handleCloseModal={handleCloseModal}
        setDatas={setDatas}
        datas={datas}
        showModal={showModal}
      />
    </>
  );
}

export default TimelineSection;
